import React, { useRef, useEffect } from 'react'
import './styles.scss'

interface Props {
  title: string
  content: string
  links: Array<string>
  open: boolean
  onClose: () => void
  onOpen: () => void
}

export const TextPanel = ({
  title,
  content,
  open,
  links,
  onClose,
  onOpen
}: Props) => {
  const contentNode = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (open) {
      onOpen()
      contentNode.current.scrollTo(0, 0)
    }
  }, [open])

  return (
    <div className={`text-panel ${open ? ' open' : ''}`}>
      <div className='panel'>
        <div className='panel-header'>
          {title}
          <div
            className='close'
            onClick={() => {
              onClose()
            }}
          >
            Fermer <i className='ui icon chevron right' />
          </div>
        </div>
        <div className='content' ref={contentNode}>
          <div dangerouslySetInnerHTML={{ __html: content }} />
          {links && (
            <div className='links'>
              {links.map((l, i) => (
                <a key={'link-' + i} href='#'>
                  {l}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
      <div
        className='dim'
        onClick={() => {
          onClose()
        }}
      />
    </div>
  )
}
